import { render } from "./TopicDetailModal.vue?vue&type=template&id=7766f5a8&scoped=true"
import script from "./TopicDetailModal.vue?vue&type=script&lang=js"
export * from "./TopicDetailModal.vue?vue&type=script&lang=js"

import "./TopicDetailModal.vue?vue&type=style&index=0&id=7766f5a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7766f5a8"]])

export default __exports__